import moment from 'moment';

export const REFUNDS_FILTERS_KEY = 'financeiro.comissoes';

export const FILTER_BY_OPTIONS = [
    { value: 'due_date', label: 'Vencimento', color: '#1890ff', icon: 'calendar' },
    { value: 'apuration_at', label: 'Apuração', color: '#722ed1', icon: 'clock-circle' },
];

export const STATUS_OPTIONS = [
    { value: 'all', label: 'Todos', color: '#1890ff', desc: 'Todas as comissões' },
    { value: 'pay', label: 'A pagar', color: '#f5222d', desc: 'Comissões pendentes de pagamento' },
    { value: 'paid', label: 'Pago', color: '#52c41a', desc: 'Comissões já pagas' },
    { value: 'get', label: 'Crédito', color: '#ffa940', desc: 'Comissões em crédito' },
    { value: 'got', label: 'Recebido', color: '#52c41a', desc: 'Comissões recebidas' },
];

const findLabel = (options, value) => {
    const option = options.find((o) => o.value === value);
    return option ? option.label : value;
};

// Defaults depend on "today", so they are built at mount (usePersistedFilters).
export const getDefaultRefundsFilters = () => {
    const currentMonth = moment().format('YYYY-MM');
    return {
        filterBy: 'due_date',
        from: currentMonth,
        to: currentMonth,
        status: 'all',
        search: '',
    };
};

// Turns the saved filter (months as 'YYYY-MM') into the /refunds/payments params.
// Builds new moments from the strings, so nothing kept in state is mutated.
export const getRefundsRequest = ({ filterBy, from, to, status }) => ({
    filter_by: filterBy,
    from: moment(from, 'YYYY-MM').startOf('month').format('YYYY-MM-DD'),
    to: moment(to, 'YYYY-MM').endOf('month').format('YYYY-MM-DD'),
    status,
});

// Same request => same server-side result (search is client-side only).
export const isSameRefundsRequest = (a, b) =>
    JSON.stringify(getRefundsRequest(a)) === JSON.stringify(getRefundsRequest(b));

// Applies the popover draft: both months required, swapped if out of order.
export const normalizeRefundsPeriod = (from, to) => {
    if (!from || !to) return null;
    if (to < from) return { from: to, to: from };
    return { from, to };
};

export const isRefundsPeriodDefault = (filters, defaults) =>
    filters.from === defaults.from && filters.to === defaults.to;

export const getRefundsPeriodLabel = (filters) =>
    moment(filters.from, 'YYYY-MM').format('MMM/YY') + ' - ' + moment(filters.to, 'YYYY-MM').format('MMM/YY');

export const getFilterByLabel = (value) => findLabel(FILTER_BY_OPTIONS, value);
export const getStatusLabel = (value) => findLabel(STATUS_OPTIONS, value);

// Badge: only what differs from the defaults.
export const countActiveRefundsFilters = (filters, defaults) =>
    (isRefundsPeriodDefault(filters, defaults) ? 0 : 1) +
    (filters.filterBy !== defaults.filterBy ? 1 : 0) +
    (filters.status !== defaults.status ? 1 : 0) +
    (filters.search ? 1 : 0);

export const filterRefundsBySearch = (data, search) => {
    const s = (search || '').toLowerCase();
    return (data || []).filter((str) => {
        if (s === '') return true;

        if (str.customer) {
            if (str.customer.name.toLowerCase().indexOf(s) >= 0) return true;
            if (str.customer.cod !== null && str.customer.cod.toLowerCase().indexOf(s) >= 0) return true;
        }

        if (str.refund.responsible.toLowerCase().indexOf(s) >= 0) return true;

        return false;
    });
};
